import { render, staticRenderFns } from "./FmcsaTable.vue?vue&type=template&id=0c1ed85a&scoped=true"
import script from "./FmcsaTable.vue?vue&type=script&lang=js"
export * from "./FmcsaTable.vue?vue&type=script&lang=js"
import style0 from "./FmcsaTable.vue?vue&type=style&index=0&id=0c1ed85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ed85a",
  null
  
)

export default component.exports